import { NgModule } from '@angular/core';

import { FacePipe } from './face.pipe';

@NgModule({
  declarations: [FacePipe],
  exports: [FacePipe],
})
export class FacePipeModule {}
